// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1LJve","log":"ModalInventoryLogs_log__1pi9_","date":"ModalInventoryLogs_date__KaP5q","userName":"ModalInventoryLogs_userName__2cj9S"};